module.exports = __webpack_public_path__ + "static/img/1-2.9cfa2aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-2.png
// module id = OrmJ
// module chunks = 1